import { render, staticRenderFns } from "./ServiceRequestChalanList.vue?vue&type=template&id=0c411a20&"
import script from "./ServiceRequestChalanList.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestChalanList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestChalanList.vue?vue&type=style&index=0&id=0c411a20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports